import {
  IIntegrationCustomer,
  IIntegrationVendor
} from "@wingspanhq/integrations/dist/lib/interfaces";
import {
  IIntegrationsQuickbooksResponse,
  IntegrationsQuickbooksAuthStatus,
  IntegrationsQuickbooksSyncStatus
} from "@wingspanhq/integrations/dist/lib/interfaces/quickbooks-api/integrationsQuickbooks";

export const isQuickbooksAuthenticated = (
  quickbooksServiceData: IIntegrationsQuickbooksResponse
) =>
  quickbooksServiceData.authStatus ===
  IntegrationsQuickbooksAuthStatus.Connected;

export const isQuickbooksSyncComplete = (
  quickbooksServiceData: IIntegrationsQuickbooksResponse
) =>
  quickbooksServiceData.syncStatus === IntegrationsQuickbooksSyncStatus.Synced;

export const isQuickbooksServiceActive = (
  quickbooksServiceData: IIntegrationsQuickbooksResponse
) =>
  quickbooksServiceData.authStatus ===
    IntegrationsQuickbooksAuthStatus.Connected &&
  quickbooksServiceData.syncStatus === IntegrationsQuickbooksSyncStatus.Synced;

export const getSortedAndGroupedVendorList = (
  vendors: IIntegrationVendor[]
) => [
  ...vendors
    .filter(vendor => vendor.primaryEmailAddress)
    .sort((a, b) =>
      a.displayName && b.displayName
        ? a.displayName
            .toLocaleLowerCase()
            .localeCompare(b.displayName.toLocaleLowerCase())
        : 0
    )
    .sort((a, b) =>
      a.primaryEmailAddress && b.primaryEmailAddress
        ? a.primaryEmailAddress
            .split("@")[1]
            .toLocaleLowerCase()
            .localeCompare(
              b.primaryEmailAddress.split("@")[1].toLocaleLowerCase()
            )
        : 0
    ),
  ...vendors
    .filter(vendor => !vendor.primaryEmailAddress)
    .sort((a, b) =>
      a.displayName && b.displayName
        ? a.displayName
            .toLocaleLowerCase()
            .localeCompare(b.displayName.toLocaleLowerCase())
        : 0
    )
];

export const getSortedAndGroupedCustomerList = (
  customers: IIntegrationCustomer[]
) => [
  ...customers
    .filter(customer => customer.primaryEmailAddress)
    .sort((a, b) =>
      a.displayName && b.displayName
        ? a.displayName
            .toLocaleLowerCase()
            .localeCompare(b.displayName.toLocaleLowerCase())
        : 0
    )
    .sort((a, b) =>
      a.primaryEmailAddress && b.primaryEmailAddress
        ? a.primaryEmailAddress
            .split("@")[1]
            .toLocaleLowerCase()
            .localeCompare(
              b.primaryEmailAddress.split("@")[1].toLocaleLowerCase()
            )
        : 0
    ),
  ...customers
    .filter(customer => !customer.primaryEmailAddress)
    .sort((a, b) =>
      a.displayName && b.displayName
        ? a.displayName
            .toLocaleLowerCase()
            .localeCompare(b.displayName.toLocaleLowerCase())
        : 0
    )
];
